import React, { useState } from 'react';
import AdminNavbar from './AdminNavbar';
import AdminSidebar from './AdminSidebar';
import ProductList from './products/ProductList';
import CategoryManager from './products/CategoryManager';
import BulkUpload from './products/BulkUpload';
import VariantManager from './products/VariantManager';
import DiscountManager from './products/DiscountManager';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const AdminProducts = () => {
  const [activeTab, setActiveTab] = useState('products');

  const renderTabContent = () => {
    switch (activeTab) {
      case 'products':
        return <ProductList />;
      case 'categories':
        return <CategoryManager />;
      case 'bulk':
        return <BulkUpload />;
      case 'variants':
        return <VariantManager />;
      case 'discounts':
        return <DiscountManager />;
      default:
        return <ProductList />;
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      <div className="fixed top-0 left-0 right-0 z-30">
        <AdminNavbar />
      </div>
      
      <div className="flex flex-1 pt-16">
        <div className="fixed top-16 left-0 bottom-0 z-20">
          <AdminSidebar />
        </div>
        
        <main className="flex-1 ml-72 pb-12">
          <ToastContainer />
          <div className="py-6 px-4 sm:px-6 lg:px-8">
            <h1 className="text-2xl font-bold text-gray-800 mb-6">Product Management</h1>
            
            <div className="border-b border-gray-200">
              <nav className="-mb-px flex space-x-8">
                {[
                  { id: 'products', name: 'Products' },
                  { id: 'discounts', name: 'Discounts' },
                  
                ].map((tab) => (
                  <button
                    key={tab.id}
                    onClick={() => setActiveTab(tab.id)}
                    className={`whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm ${
                      activeTab === tab.id
                        ? 'border-indigo-500 text-indigo-600'
                        : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                    }`}
                  >
                    {tab.name}
                  </button>
                ))}
              </nav>
            </div>
            
            <div className="mt-6">
              {renderTabContent()}
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default AdminProducts;